import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import { NotificationManager } from "react-notifications";
import { makeStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import useEquipmentsTable from "./useEquipmentsTable.js";
import Button from "components/CustomButtons/Button.js";
import styled from "styled-components";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import UserService from "services/UserService";
import { getSchedules } from "services/ConfigServices";
import { equipmenttext, pointtext } from "variables/MBM/equipments";
import { definitionData, fieldprotocoleData, eosprotocoleData, stateData } from "variables/MBM/lists/equipments";
import { dico } from "variables/lists/dico";
import Dialog from "@mui/material/Dialog";
import { withStyles } from "@mui/styles";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import ViewPointDataDialog from "./ViewPointDataDialog";
import PointDialog from "./PointDialog";

const GroupCell = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const Container = styled.div`
  border: solid;
  border-width: 1px;
  border-color: #EEEEEE;
  background-color: white;
  margin-top: -0.5px;
  padding-top: 5px;
  overflow-x: auto;
  width: 100%;
`;

const ExpandableContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0.5rem 4rem 2rem;
`;
const ExpandableElement = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: ${(props) => props.marginleft};
`;

const ElementTitle = styled.div`
  font-weight: 600;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const ElementData = styled.div`
  margin-left: 4px;
  font-weight: 400;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;


const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const useStyles = makeStyles(styles);

const RTEquipments = () => {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const mbm_admin = permis.includes("mbm_admin");
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = appContext;
  const { gridState, refetch, setEquipments, setPoints, pointsdata, equipmentsdata, displaymethod } = useEquipmentsTable();

  const [schedulesData, setSchedulesData] = useState([]);
  const [point, setPoint] = useState(null);

  const [openPoint, setOpenPoint] = useState(false);
  const [openPointData, setOpenPointData] = useState(false);

  const classes = useStyles();

  useEffect(() => {
    if (chartIdGroup > 0) {
      axios
        .get(
          getSchedules(chartIdGroup),
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        )
        .then((res) => {
          let tmpSchedulesData = res.data.schedules?.map((data) => {
            return (
              { name: data.parameters.name, id: data.id, destination: data.destination }
            );
          });
          setSchedulesData(tmpSchedulesData || []);
        });
    }
  }, [chartIdGroup]);

  const equipmentscolumns = [
    {
      name: equipmenttext.name,
      selector: (row) => row.name,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.name,
    },
    {
      name: equipmenttext.definition,
      selector: (row) => row.definition,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => definitionData.find((x) => x.id == row.definition)?.name || ""
    },
    {
      name: equipmenttext.fieldprotocol,
      selector: (row) => row.connectionproperties?.fieldProtocol,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => fieldprotocoleData.find((x) => x.id == row.connectionproperties?.fieldProtocol)?.name || ""
    },
    {
      name: equipmenttext.eosprotocol,
      selector: (row) => row.connectionproperties?.eosprotocol,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => eosprotocoleData.find((x) => x.id == row.connectionproperties?.eosprotocol)?.name || ""
    },
    {
      name: equipmenttext.group,
      selector: (row) => row.groupid,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => groupInfoListById["" + row.groupid] || ""
    },
  ];

  const pointscolumns = [
    {
      name: pointtext.name,
      selector: (row) => row.name,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.name,
    },
    {
      name: pointtext.definition,
      selector: (row) => row.definition,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => dico.find((x) => x.id == row.definition)?.name || ""
    },
    {
      name: pointtext.state,
      selector: (row) => row.state,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => stateData.find((x) => x.id == row.state)?.name || ""
    },
    {
      name: pointtext.equipment,
      selector: (row) => row.equipment,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => equipmentsdata.find((x) => x.id == row.equipment)?.name || ""
    },
    {
      name: pointtext.schedule,
      selector: (row) => row.schedule,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => schedulesData.find((x) => x.id == row.schedule)?.name || ""
    },

    // {
    //   name: pointtext.lastdate,
    //   selector: (row) => row.lastdate,
    //   sortable: true,
    //   maxWidth: "12rem",
    //   cell: (row) =>
    //     row.lastdate && moment(row.lastdate).isValid()
    //       ? moment(row.lastdate).format("DD/MM/YYYY HH:mm")
    //       : "",
    // },
    // {
    //   name: pointtext.lastvalue,
    //   selector: (row) => row.lastvalue,
    //   sortable: true,
    //   maxWidth: "10rem",
    //   cell: (row) => row.lastvalue ? new Intl.NumberFormat('fr-FR').format(row.lastvalue) : ""
    // },
    // {
    //   name: pointtext.unit,
    //   selector: (row) => row.definition,
    //   sortable: true,
    //   maxWidth: "12rem",
    //   cell: (row) => dico.find((x) => x.id == row.definition)?.unit || ""
    // },
    {
      name: pointtext.group,
      selector: (row) => row.connectionproperties?.fieldProtocol,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => groupInfoListById["" + row.groupid] || ""
    },
    {
      name: "",
      sortable: false,
      width: "10rem",
      // eslint-disable-next-line react/button-has-type
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>

          <div className="actions-right">
            {mbm_admin && (
              <Tooltip title="Editer le point">
                <Button
                  onClick={editPoint(row)}
                  color={"warning"}
                  className={classes.actionButton}
                >
                  <EditIcon fontSize="large" />
                </Button>
              </Tooltip>
            )}
          </div>
        </>
      ),
    },
  ];

  const viewPointData = (row) => async () => {
    let obj = pointsdata.find((o) => o.id === row.id);
    setPoint(obj);
    handleViewPointDataOpen();
  };
  const editPoint = (row) => async () => {
    let obj = pointsdata.find((o) => o.id === row.id);
    let eq = equipmentsdata.find((o) => o.id === row.equipment);
    if (obj) {
      obj.equipmentName = eq.name;
      setPoint(obj);
      handleViewPointOpen();
    }
  }

  const ExpandableComponent = props => {
    const { data } = props;
    const datadisplay = pointsdata.filter((x) => x.equipment === data.id);

    return (
      <Container>
        <DataTable
          paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
          noDataComponent={<NoData>Aucun PDL à afficher</NoData>}
          noHeader={true}
          columns={pointscolumns}
          persistTableHead
          data={datadisplay}
          striped={true}
        //theme="solarized"
        />
      </Container>
    );
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const handleSelectedRowsChange = (selection) => {
    if (displaymethod === 'equipments')
      setEquipments(selection.selectedRows);
    else if (displaymethod === 'points')
      setPoints(selection.selectedRows);
  };

  const handleViewPointDataOpen = () => {
    setOpenPointData(true);
  };
  const handleViewPointDataClose = () => {
    setOpenPointData(false);
  };
  const handleViewPointOpen = () => {
    setOpenPoint(true);
  };
  const handleViewPointClose = () => {
    setOpenPoint(false);
  };

  return (
    <>
      <DataTable
        paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
        noDataComponent={<NoData>Aucun équipement à afficher</NoData>}
        noHeader={true}
        columns={displaymethod === 'equipments' ? equipmentscolumns : displaymethod === 'points' ? pointscolumns : []}
        persistTableHead
        pagination
        subHeader
        onSelectedRowsChange={handleSelectedRowsChange}
        selectableRows={true}
        progressPending={gridState.loading}
        progressComponent={<LinearProgress />}
        expandOnRowClicked={displaymethod === 'equipments'}
        expandableRows={displaymethod === 'equipments'}
        expandableRowDisabled={(row) => row.disabled}
        expandableRowsComponent={ExpandableComponent}
        paginationComponentOptions={{
          noRowsPerPage: false,
          rowsPerPageText: "Lignes par page",
          rangeSeparatorText: "sur",
          selectAllRowsItem: false,
          selectAllRowsItemText: "Selectionner toutes les lignes",
        }}
        {...gridState}
      />
      <Dialog
        onClose={handleViewPointClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="sm"
        open={openPoint}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleViewPointClose}>
          Pilotage de {point?.name}
        </CustomDialogTitle>
        <DialogContent dividers>
          <PointDialog
            point={point}
            schedulesData={schedulesData}
            chartIdGroup={chartIdGroup}
            closeModal={handleViewPointClose}
            refetch={refetch}
            setNotification={setNotification}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
      <Dialog
        onClose={handleViewPointDataClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="md"
        open={openPointData}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleViewPointDataClose}>
          Données de {point?.name}
        </CustomDialogTitle>
        <DialogContent dividers>
          <ViewPointDataDialog
            point={point}
            closeModal={handleViewPointDataClose}
            refetch={refetch}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </>
  );
};

export default RTEquipments;
